import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

export default class Breadcrumb extends React.Component {

    render() {
        const { breadcrumbs } = this.props;

        return (
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    {
                        breadcrumbs.map((breadcrumb, index) => {
                            const { id, url, description, loading } = breadcrumb;
                            const isLastItem = breadcrumbs.length - 1 === index;

                            return (
                                <li key={id}>
                                    <Link
                                        to={url}
                                        disabled={isLastItem || loading || !url}
                                        children={loading ? 'Cargando...' : description}
                                    />
                                </li>
                            );
                        })
                    }
                </ol>
            </nav>
        );
    }
}

Breadcrumb.propTypes = {
    breadcrumbs: PropTypes.array.isRequired,
};

Breadcrumb.defaultProps = {
    breadcrumbs: null,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/Breadcrumb.jsx